import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


function UserDropdown({ username, logout }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const go = (path) => {
    closeDropdown();
    navigate(path);
  };

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button
        className="btn btn-sm btn-outline dropdown-toggle"
        type="button"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
      >
        {username}
      </button>

      {isOpen && (
        <ul className="dropdown-menu dropdown-menu-end show" style={{ position: 'absolute' }}>
          <li>
            <button className="dropdown-item" type="button" onClick={() => go('/account/profile')}>
              <i className="fa fa-user me-2" /> Profile
            </button>
          </li>
          <li>
            <button className="dropdown-item" type="button" onClick={() => go('/account/orders')}>
              <i className="fa fa-box me-2" /> My Orders
            </button>
          </li>
          <li>
            <button className="dropdown-item" type="button" onClick={() => go('/account/wishlist')}>
              <i className="fa fa-heart me-2" /> Wishlist
            </button>
          </li>
          <li><hr className="dropdown-divider" /></li>
          <li>
            <button
              className="dropdown-item text-danger"
              type="button"
              onClick={() => {
                logout();
                navigate('/');
              }}
            >
              <i className="fa fa-sign-out-alt me-2" /> Logout
            </button>
          </li>
        </ul>
      )}
    </div>
  );
}

export default UserDropdown;
